<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="mt-4 sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Messages</h1>
        <p class="mt-2 text-sm text-gray-700">
          A list of all the Messages
        </p>
      </div>
    </div>
    <div
      class="flex flex-wrap items-center justify-end py-3 mt-2 ml-4 mr-4 space-y-2 bg-white rounded-lg sm:space-y-0 sm:space-x-4"
    >
      <div class="flex items-center px-3 space-x-2">
        <label for="search" class="text-sm font-medium text-gray-700">
          Search:
        </label>
        <input
          id="search"
          v-model="filters.search"
          @input="applyFilters"
          type="text"
          placeholder="search by user or phone"
          class="px-3 py-2 border rounded shadow-sm focus:ring focus:ring-blue-200"
        />
      </div>
      <div class="flex items-center px-3 space-x-4">
        <label class="text-sm font-medium text-gray-700">Type:</label>
        <div class="flex items-center space-x-2">
          <input
            type="radio"
            id="incoming"
            value="1"
            v-model="filters.is_incoming"
            @change="applyFilters"
            class="form-radio"
          />
          <label for="incoming" class="text-sm">Incoming</label>

          <input
            type="radio"
            id="outgoing"
            value="0"
            v-model="filters.is_incoming"
            @change="applyFilters"
            class="form-radio"
          />
          <label for="outgoing" class="text-sm">Outgoing</label>

          <input
            type="radio"
            id="all"
            value=""
            v-model="filters.is_incoming"
            @change="applyFilters"
            class="form-radio"
          />
          <label for="all" class="text-sm">All</label>
        </div>
      </div>
      <div class="flex items-center px-3 space-x-2">
        <label for="search" class="text-sm font-medium text-gray-700">
          Total Messages: {{ pagination.total }}
        </label>
      </div>
    </div>

    <div class="px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col mt-4">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"
          >
            <div
              class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Phone
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Template
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Type
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Service Request ID
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Text
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      User
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr v-for="item in messages" :key="item.id">
                    <td
                      class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-0"
                    >
                      {{ item.created_at | convertDate }}
                    </td>
                    <td
                      class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-0"
                    >
                      {{ item.phone }}
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      {{ item.template_id }}
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      {{ item.status }}
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      <span
                        v-if="item.is_incoming"
                        class="inline-flex items-center px-2 py-1 text-xs font-medium text-green-700 rounded-full bg-green-50 ring-1 ring-inset ring-green-600/20"
                        >Incoming</span
                      >
                      <span
                        v-else
                        class="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-700 rounded-full bg-indigo-50 ring-1 ring-inset ring-indigo-700/10"
                        >Outgoing</span
                      >
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      <a
                        v-if="item.service_request"
                        class="underline"
                        :href="
                          '/serviceRequests/flow/' +
                            item.service_request.service_request_id
                        "
                        >{{
                          item.service_request &&
                            item.service_request.service_request_number
                        }}</a
                      >
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      {{ item.text }}
                    </td>
                    <td
                      v-if="item.user"
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      {{ item.user.first_name }} {{ item.user.last_name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="flex items-center justify-between p-2 px-4 mt-4 bg-white rounded-lg"
            >
              <!-- Records Per Page Selector -->
              <div class="flex items-center space-x-2">
                <label for="per-page" class="text-sm font-medium"
                  >Records per page:</label
                >
                <select
                  id="per-page"
                  v-model="perPage"
                  @change="getMessages()"
                  class="px-2 py-1 border rounded"
                >
                  <option
                    v-for="option in perPageOptions"
                    :key="option"
                    :value="option"
                  >
                    {{ option }}
                  </option>
                </select>
              </div>
              <Pagination
                :currentPage="pagination.current_page"
                :totalPages="pagination.last_page"
                @page-change="handlePageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from "date-fns";
import Pagination from "../../components/Pagination.vue";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";

export default {
  data() {
    return {
      messages: [],
      pagination: {},
      perPage: 10,
      perPageOptions: [5, 10, 25, 50],
      paginationLinks: [],
      filters: {
        search: "",
        is_incoming: ""
      }
    };
  },
  components: {
    Pagination
  },
  filters: {
    convertDate(date) {
      return format(date, "DD MMM YYYY");
    }
  },
  mounted() {
    this.getMessages();
  },

  methods: {
    applyFilters() {
      const { search, is_incoming } = this.filters;
      const page = this.pagination.current_page || 1; // Default to page 1 if undefined
      let url = `/api/v1/messages?page=${page}&per_page=${this.perPage}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      if (is_incoming !== "") url += `&is_incoming=${is_incoming}`;
      this.getMessages(url);
    },

    resetFilters() {
      this.filters.search = "";
      this.filters.is_incoming = "";
      this.getMessages(`/api/v1/messages?page=1&per_page=${this.perPage}`);
    },

    handlePageChange(page) {
      const { search, is_incoming } = this.filters;
      let url = `/api/v1/messages?page=${page}&per_page=${this.perPage}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      if (is_incoming !== "") url += `&is_incoming=${is_incoming}`;

      this.getMessages(url);
    },

    getMessages(url = `/api/v1/messages?page=1&per_page=${this.perPage}`) {
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}${url}`)
        .then(response => {
          this.messages = response.data.data;
          this.pagination = {
            current_page: response.data.current_page,
            prev_page_url: response.data.prev_page_url,
            next_page_url: response.data.next_page_url,
            last_page: response.data.last_page,
            total: response.data.total
          };
          this.generatePaginationLinks();
        });
    },
    generatePaginationLinks() {
      const links = [];
      for (let i = 1; i <= this.pagination.last_page; i++) {
        links.push({
          number: i,
          url: `/api/v1/messages?page=${i}&per_page=${this.perPage}`,
          active: i === this.pagination.current_page
        });
      }
      this.paginationLinks = links;
    }
  }
};
</script>
